import styled, { css } from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
/**
 * Mixin that provides a set of unified border styles for usage in various
 * components that require visual dividers
 *
 * @param {LogicalOrientation} orientation
 */
export function injectDividerBorderStyle(orientation) {
    return css `
    border-${orientation}-width: 1px;
    border-${orientation}-style: solid;
    border-${orientation}-color: var(${(props) => props.theme.colors.ui.divider});
  `;
}
export const StyledDivider = styled.hr.withConfig({ displayName: "auir-611444a-StyledDivider", componentId: "auir-611444a-yg17f8" }) `
  height: 0;
  margin: 0;

  border: none;
  ${injectDividerBorderStyle('block-start')}

  ${injectSpacing('margin')}
`;
//# sourceMappingURL=Divider.styles.mjs.mjs.map